import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import logo from '../../../public/catch-logo2.png';
import findById from '../../core/utils';
import UserMenu from './UserMenu';

// 'tour_management'
// 'travel_management'
// 'brand_management'
// 'hotel_management'
// 'mobile_access'
const bookingItem = {
  key: 'booking',
  to: '/booking',
  name: 'Requests',
  icon: 'fa fa-inbox',
};
const bidItem = {
  key: 'booking',
  to: '/booking',
  name: 'Requests',
  icon: 'fa fa-inbox',
};
const tourItem = {
  key: 'tour',
  to: '/tours',
  name: 'Travel Projects',
  icon: 'fa fa-suitcase',
};
const hotelItem = {
  key: 'manage-hotels',
  to: '/hotels',
  name: 'Manage Hotels',
  icon: 'fa fa-h-square',
};
const addHotelItem = {
  key: 'add-hotels',
  to: '/addhotel',
  name: 'Add Hotel',
  icon: 'fa fa-plus',
};
const browseHotelItem = {
  key: 'browse-hotels',
  to: '/browse/hotels',
  name: 'Search Hotels',
  icon: 'fa fa-h-square',
};

const commissionItem = {
  key: 'commission',
  to: '/commissions',
  name: 'Commissions',
  icon: 'fa fa-usd',
};
const supportItem = {
  key: 'support',
  to: '/support',
  name: 'Support',
  icon: 'fa fa-user-circle',
};

export const menuByPermission = {
  brand_management: [bookingItem],
  hotel_management: [bidItem, hotelItem, addHotelItem],
  mobile_access: [],
  tour_management: [],
  travel_management: [tourItem, commissionItem, browseHotelItem],
};
const profileItem = {
  key: 'profile',
  to: '/profile',
  name: 'Profile',
};
const agencyItem = {
  key: 'agency',
  to: '/agency',
  name: 'Company',
  icon: 'fa fa-building-o',
};

export const userMenuByPermission = {
  brand_management: [],
  hotel_management: [supportItem],
  mobile_access: [],
  tour_management: [],
  travel_management: [agencyItem,supportItem],
};
function findByKey(value) {
  return value.key === this;
}

function formatIcon(menu) {
  if (menu.icon) {
    return <i className={menu.icon} aria-hidden="true" />;
  }
  return null;
}
class Header extends React.Component {
  getCSS() {
    if (this.props.isActive) {
      return 'sidebar';
    }
    return 'sidebargone sidebar';
  }
  toggleText() {
    if (this.props.isActive) {
      return 'COLLAPSE';
    }
    return 'EXPAND';
  }
  render() {
    const menuItems = [];
    const userMenu = [];

    if (this.props.profile.user) {
      this.props.perms.forEach(perm => {
        const userMenuPartial = userMenuByPermission[perm];
        if (userMenuPartial) {
          userMenuPartial.forEach(um => {
            userMenu.push(um);
          });
        }
        const miniMenu = menuByPermission[perm];
        if (miniMenu) {
          miniMenu.forEach(menu => {
            const idx = menuItems.findIndex(findByKey, menu.key);
            if (idx === -1) {
              const icon = formatIcon(menu);
              menuItems.push(
                <Link key={menu.key} to={menu.to}>
                  <li className="list-group-item d-flex align-items-center">
                    {icon}
                    <h5>{menu.name}</h5>
                  </li>
                </Link>
              );
            }
          });
        }
      });

      return (
        <div className={this.getCSS()}>
          <tt className="toggle-text" role="presentation" onClick={this.props.toggleActive}>
            {this.toggleText()}
          </tt>
          <div className="sidebar-logo-container">
            <span className="center-img" />
            <Link to="/">
              <img className="sidebar-img" src={logo} alt="CATCH" />
            </Link>
          </div>
          <ul className="list-group">{menuItems}</ul>

          <UserMenu
            profile={this.props.profile}
            menu={userMenu}
            perms={this.props.perms}
            logout={this.props.logout}
          />
        </div>
      );
    }
    return (
      <div className="sidebar col-md-2">
        <Link to="/">
          <div className="sidebar-logo-container">
            <span className="center-img" />
            <img className="sidebar-img" src={logo} alt="CATCH" />
          </div>
        </Link>
        <hr />
        <ul className="list-group">{menuItems}</ul>
        <UserMenu profile={{}} menu={[]} perms={[]} logout={this.props.logout} />
      </div>
    );
  }
}

Header.propTypes = {
  profile: PropTypes.object.isRequired,
  perms: PropTypes.arrayOf(PropTypes.string).isRequired,
  userMenu: PropTypes.arrayOf(PropTypes.object).isRequired,
  menu: PropTypes.arrayOf(PropTypes.object).isRequired,
  logout: PropTypes.func.isRequired,
  toggleActive: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};
Header.defaultProps = {
  brand: 'Use Catch',
  profile: {},
  perms: [],
  menu: [],
  userMenu: [],
};

export default Header;



// WEBPACK FOOTER //
// src/components/Sidebar/Sidebar.js